import { useContext } from 'react';

import { PlaceSearchStateEnum } from '../components/sections/sectionGlobalSearch/types';
import { AppContext } from '../context/app';

export const useCancelSearchFocus = () => {
  const { setGlobalSearchText, setShowKeyboard, setPlaceSearchState } =
    useContext(AppContext);
  return () => {
    setGlobalSearchText(undefined);
    setShowKeyboard(false);
    setPlaceSearchState(PlaceSearchStateEnum.DISPLAYCATEGORIES);
  };
};
